import React from 'react';
import Icon from '../../../components/AppIcon';

const WidgetUsageHeatmap = ({ data }) => {
  const getEngagementColor = (adoptionRate) => {
    if (adoptionRate >= 80) return 'bg-success/20 text-success border-success/30';
    if (adoptionRate >= 60) return 'bg-accent/20 text-accent border-accent/30';
    if (adoptionRate >= 40) return 'bg-warning/20 text-warning border-warning/30';
    return 'bg-error/20 text-error border-error/30';
  };

  const getWidgetIcon = (widgetType) => {
    const icons = {
      compliance_score: 'Shield',
      alert_summary: 'Bell',
      violation_trends: 'TrendingDown',
      department_performance: 'BarChart',
      payroll_sync_status: 'DollarSign',
      cost_analysis: 'PieChart',
      deadline_countdown: 'Clock',
      kpi_metric: 'Activity'
    };
    return icons?.[widgetType] || 'Layout';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 h-full">
      <div className="mb-6">
        <h3 className="font-heading font-semibold text-base md:text-lg text-foreground mb-1">
          Widget Usage Heatmap
        </h3>
        <p className="caption text-xs md:text-sm text-muted-foreground">
          Adoption rates and interaction frequency
        </p>
      </div>

      <div className="space-y-3 max-h-96 overflow-y-auto">
        {data?.slice(0, 10)?.map((widget, index) => (
          <div 
            key={index}
            className="flex items-center gap-3 p-3 bg-muted/30 rounded-md hover:bg-muted/50 transition-smooth"
          >
            <div className="flex-shrink-0">
              <div className="bg-primary/10 text-primary p-2 rounded-md">
                <Icon name={getWidgetIcon(widget?.widgetType)} size={18} color="currentColor" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-heading text-sm font-medium text-foreground truncate">
                {widget?.widgetName}
              </p>
              <p className="caption text-xs text-muted-foreground">
                {widget?.interactions} interactions • {widget?.avgTimeSpent}s avg
              </p>
            </div>
            <div className="flex-shrink-0">
              <div className={`px-3 py-1 rounded-full border ${getEngagementColor(widget?.adoptionRate)}`}>
                <span className="data-text text-xs font-bold">
                  {widget?.adoptionRate}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 pt-4 border-t border-border">
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-success"></div>
            <span className="caption text-muted-foreground">High (≥80%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-accent"></div>
            <span className="caption text-muted-foreground">Good (60-79%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-warning"></div>
            <span className="caption text-muted-foreground">Fair (40-59%)</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-error"></div>
            <span className="caption text-muted-foreground">Low (&lt;40%)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WidgetUsageHeatmap;